import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class BakeryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.BAKERY;
}

export default BakeryBuildingTileEntity;
